import MobileDetect from 'mobile-detect';
import { MOBILE_WIDTH_POINT } from '../constants/device';

const MOBILE_WIDTH = 900;
// 不要用此判斷手機，改用 getIsMobile
const isMobile = screenWidth => screenWidth <= MOBILE_WIDTH;

const getIsMobile = () => {
  const md = new MobileDetect(window.navigator.userAgent);

  return !!md.mobile();
};
let id;
const uniqueId = () => {
  if (!id) {
    // Math.random should be unique because of its seeding algorithm.
    // Convert it to base 36 (numbers + letters), and grab the first 9 characters
    // after the decimal.
    id = `_${Math.random()
      .toString(36)
      .substr(3, 16)}`;
  }
  return id;
};

const getIsWebview = () => {
  const useragent = navigator.userAgent;
  const rules = [
    'WebView',
    '(iPhone|iPod|iPad)(?!.*Safari/)',
    'Android.*(wv|.0.0.0)',
  ];
  const regex = new RegExp(`(${rules.join('|')})`, 'ig');
  return Boolean(useragent.match(regex));
};

const isLineBrowser = () => {
  const useragent = navigator.userAgent.toLowerCase();

  return useragent.indexOf('line') !== -1;
};

/**
 * Description 判斷網頁的寬度是 < 980px 則視為小裝置, 樣式使用手機版本顯示
 * @returns {boolean}
 */
const isWebSmDevice = () => {
  const md = new MobileDetect(window.navigator.userAgent);
  const smallWidthDesktop = window.matchMedia(
    `(max-width: ${MOBILE_WIDTH_POINT}px)`,
  );
  // is phone and tablet
  const isOnMobile = md.mobile() !== null;

  if (isOnMobile) {
    return true;
  }

  if (!isOnMobile && smallWidthDesktop.matches) {
    return true;
  }

  return false;
};

/**
 * Description 判斷 planner tool 是顯示在 1. 手機 2.桌面/pad版本。
 * @returns {boolean}
 */
const isPlannerToolOnPhone = () => {
  const md = new MobileDetect(window.navigator.userAgent);
  const isPhone = md.phone() !== null;

  return isPhone;
};

export {
  MOBILE_WIDTH,
  isMobile,
  uniqueId,
  getIsMobile,
  getIsWebview,
  isLineBrowser,
  isWebSmDevice,
  isPlannerToolOnPhone,
};
